import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsFetching, selectServices, selectServicesSelected } from 'store/Services/selectors';
import servicesSchema from './schema';
import { selectFields } from 'store/Preferences/service/selectors';
import SharedTable from 'shared/ui/Table';
import { setOrderByServices } from 'store/Services/actions';
import { selectOrderBy } from 'store/Filters/selectors';
import NoSearchResults from 'Common/Components/NoSearchResults';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_TAGS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const ServicesTable = () => {
  const servicesData = useSelector(selectServices);
  const isFetching = useSelector(selectIsFetching);
  const fields = useSelector(selectFields);
  const isTagsAllowedByLicense = useSelector((state) => selectAllowedByRole(state, FEATURE_TAGS, PERMISSION_TYPES.READ));
  const servicesSelected = useSelector((state) => selectServicesSelected(state));
  const orderBy = useSelector((state) => selectOrderBy('services', state));
  const defaultSorted = orderBy.map(({ field, direction }) => ({ id: field, desc: direction === 'desc' }));
  const dispatch = useDispatch();

  const isRowSelected = (rowInfo) => !!servicesSelected.find((vuln) => vuln._id === rowInfo.original._id);

  const getThProps = (column, fields) => {
    const defaultMin = fields[column.id] ? fields[column.id].defaultWidth : 0;
    const maxWidth = fields[column.id] ? fields[column.id].maxWidth : 0;
    const response = { minWidth: defaultMin, maxWidth };
    return {
      style: defaultMin ? response : {}
    };
  };

  const fetchData = (sorted) => !isFetching && dispatch(setOrderByServices(sorted));

  return (
    <SharedTable
      schema={ servicesSchema }
      context={ { fields, isFetching, isTagsAllowedByLicense } }
      data={ servicesData }
      isLoading={ isFetching }
      defaultSorted={ defaultSorted }
      onFetch={ fetchData }
      isRowSelected={ isRowSelected }
      getHeaderProps={ (column) => getThProps(column, fields) }
      noDataText={ !isFetching && <NoSearchResults /> }
    />
  );
};

export default ServicesTable;
